export default "__VITE_ASSET__DZQIt8_V__"